if (!customElements.get('hitch-wompi')) {
  class HitchWompi extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.trigger = this.querySelector('[data-hitch-wompi-open]');
      this.modal = this.querySelector('.hitch-wompi-modal');
      this.closeButton = this.querySelector('[data-hitch-wompi-close]');
      this.trigger?.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.close());
      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.close();
      });
      this.modal?.addEventListener('close', () => this.handleModalClose());
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          this.updateAmount(data?.variant?.price);
        });
      }
      this.updateAmount(this.dataset.rawPrice);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      if (this.modal?.open) this.modal.close();
      document.body.classList.remove('hitch-wompi-modal-open');
    }

    open() {
      if (!this.modal) return;
      if (typeof this.modal.showModal === 'function') this.modal.showModal();
      else this.modal.setAttribute('open', '');
      document.body.classList.add('hitch-wompi-modal-open');
      this.trigger?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.closeButton?.focus());
    }

    close() {
      if (!this.modal) return;
      if (typeof this.modal.close === 'function' && this.modal.open) this.modal.close();
      else {
        this.modal.removeAttribute('open');
        this.handleModalClose();
      }
    }

    handleModalClose() {
      document.body.classList.remove('hitch-wompi-modal-open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (document.activeElement !== this.trigger) this.trigger?.focus();
    }

    updateAmount(price) {
      const priceInCents = Number(price);
      const installments = Number(this.dataset.installments || 4);
      if (!Number.isFinite(priceInCents) || !installments) return;
      this.dataset.rawPrice = String(priceInCents);
      const installmentPrice = Math.floor(priceInCents / installments);
      this.querySelectorAll('[data-wompi-amount]').forEach((element) => {
        element.textContent = this.formatMoney(installmentPrice);
      });
    }

    formatMoney(priceInCents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', {
          style: 'currency',
          currency: this.dataset.currency || 'COP',
          currencyDisplay: this.dataset.currencyCodeEnabled === 'true' ? 'code' : 'symbol',
          maximumFractionDigits: 0,
        }).format(priceInCents / 100);
      } catch (error) {
        return `$ ${Math.floor(priceInCents / 100).toLocaleString('es-CO')}`;
      }
    }
  }
  customElements.define('hitch-wompi', HitchWompi);
}
